export interface RouteInfo {
    path: string;
    title: string;
    type: string;
    icon: string;
    collapse?: string;
    children?: ChildrenItems[];
    roles?: any;
}

export interface ChildrenItems {
    path: string;
    title: string;
    ab: string;
    type?: string;
}

//Menu Items
export const ROUTES: RouteInfo[] = [{
    path: '/home',
    title: 'Home',
    type: 'link',
    icon: 'fal fa-home'
}, {
    path: '/components',
    title: 'UI Components',
    type: 'sub',
    icon: 'fal fa-list-ul',
    collapse: 'components',
    children: [
        { path: 'buttons', title: 'Buttons', ab: 'B' },
        { path: 'forms', title: 'Form Inputs', ab: 'F' },
        { path: 'cards', title: 'Cards', ab: 'C' },
        { path: 'menus', title: 'Menus', ab: 'M' },
        { path: 'modals', title: 'Modals', ab: 'M' },
        { path: 'alerts', title: 'Alerts', ab: 'A' },
        { path: 'tooltips', title: 'Tooltips', ab: 'T' },
        { path: 'grid', title: 'Grid System', ab: 'GS' },
        { path: 'typography', title: 'Typography', ab: 'T' }
    ]
    }, {
        path: '/forms',
        title: 'Forms',
        type: 'sub',
        icon: 'fal fa-edit',
        collapse: 'forms',
        children: [
            { path: 'simple', title: 'Simple', ab: 'S' },
            { path: 'modal', title: 'Modal', ab: 'M' },
            { path: 'responsive', title: 'Responsive', ab: 'R' },
            { path: 'validation', title: 'Validation', ab: 'V' },
            { path: 'multistep', title: 'Multi-Step', ab: 'MS' }
        ]
    }, {
        path: '/sample',
        title: 'Sample Grid',
        type: 'link',
        icon: 'fal fa-table',
        roles: ['SampleViewer', 'SampleAdmin', 'SystemAdmin']
    }, {
        path: '/user',
        title: 'User Grid',
        type: 'link',
        icon: 'fal fa-users',
        roles: ['SystemAdmin']
    }
];
